import * as React from 'react';
import {
    CreateButton,
    DateField,
    FilterButton,
    List,
    SearchInput,
    TopToolbar,
    TextField,
    DatagridConfigurable,
    SelectColumnsButton,
    WithListContext,
    DatagridLoading,
    Pagination,
    FunctionField,
} from 'react-admin';
import { useMediaQuery, Theme, Chip } from '@mui/material';

const userFilters = [<SearchInput source="q" alwaysOn />];

const ListActions = () => {
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        <TopToolbar>
            {isSmall ? <FilterButton /> : null}
            <SelectColumnsButton />
            <CreateButton />
        </TopToolbar>
    );
};

interface SecretsListProps {
    embedded?: boolean;
}

const SecretsList = ({ embedded }: SecretsListProps) => {
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));

    const listProps = embedded
        ? {
              resource: 'admin/secrets',
              storeKey: 'admin/secrets',
              actions: <ListActions />,
              title: ' ',
              sx: { '& .RaList-main': { mt: 0 } },
          }
        : { actions: <ListActions /> };

    return (
        <List
            filters={isSmall ? userFilters : userFilters}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={50}
            pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}
            {...listProps}
        >
            <WithListContext
                render={({ isLoading, isFetching }) =>
                    isLoading || isFetching ? (
                        <DatagridLoading nbChildren={5} nbFakeLines={8} />
                    ) : (
                        <DatagridConfigurable rowClick="show">
                            <TextField source="name" />
                            <TextField source="description" />
                            <DateField
                                source="createdDate"
                                showTime
                                locales="fi-FI"
                            />
                            <DateField
                                source="lastChangedDate"
                                showTime
                                locales="fi-FI"
                            />
                            <DateField
                                source="lastAccessedDate"
                                showTime={false}
                                locales="fi-FI"
                            />
                            <FunctionField
                                source="deletionDate"
                                render={(record: any) =>
                                    record?.deletionDate ? (
                                        <Chip
                                            label="Scheduled for deletion"
                                            color="error"
                                            size="small"
                                        />
                                    ) : null
                                }
                            />
                        </DatagridConfigurable>
                    )
                }
            />
        </List>
    );
};

export default SecretsList;
